export default __webpack_public_path__ + "static/media/img-detail-selected.80f9240e.svg";